// IELTS Mock 7 — Listening (IELTS Fever Listening Practice Test 10)
// Same shape as IELTS_DATA_LISTENING in ../IeltsListening.js (4 parts, 40 questions,
// one audio track that plays once straight through).
// Groups with `optionsBox` show a text box of lettered options instead of an image.
// Groups with `flow` render as a flow-chart: a step's `qid`/`qids` hold its question(s),
// steps with only `text` are fixed boxes.
// No `audioStart` timings yet, so the page doesn't auto-scroll between Parts.

const AUDIO_SRC = "/audio/ielts_listening7.mp3";

const IELTS_MOCK7_LISTENING = {
  title: "IELTS Listening Mock 7",
  sections: [
    {
      id: "s1",
      title: "Section 1: A Conversation after Commencement",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Questions 1–5: Choose the correct letter, A, B or C.",
          image: null,
          questions: [
            {
              id: "q1",
              text: "What is Harry's problem?",
              type: "mcq",
              options: [
                "A. He doesn't want to sell his things.",
                "B. He needs to decide what to do with his possessions.",
                "C. He would like to take everything to England.",
              ],
              answer: "B",
            },
            {
              id: "q2",
              text: "Which of the following items does Harry want to sell?",
              type: "mcq",
              options: ["A. Sleeping bag.", "B. Kitchen furniture.", "C. Household appliances."],
              answer: "C",
            },
            {
              id: "q3",
              text: "Where is Harry going to advertise his books for sale?",
              type: "mcq",
              options: [
                "A. In the university bookshop.",
                "B. In the student newspaper.",
                "C. In the economics department.",
              ],
              answer: "C",
            },
            {
              id: "q4",
              text: "Andrea thinks it is unlikely students will purchase the furniture because",
              type: "mcq",
              options: [
                "A. They're all doing the same thing.",
                "B. They live at home.",
                "C. It's the summer vacation.",
              ],
              answer: "C",
            },
            {
              id: "q5",
              text: "Andrea thinks that a second-hand shop",
              type: "mcq",
              options: [
                "A. May not pay well.",
                "B. May not take your goods.",
                "C. May only take free goods.",
              ],
              answer: "A",
            },
          ],
        },
        {
          instruction: "Questions 6–10: Complete Harry's notes using ONE WORD ONLY.",
          heading: "Things to do",
          image: null,
          questions: [
            { id: "q6", text: "Post furniture ______", type: "fill_blank", answer: ["advertisement"] },
            { id: "q7", text: "______ or sell kitchen things.", type: "fill_blank", answer: ["donate"] },
            { id: "q8", text: "Get a ______ first from the second-hand shop.", type: "fill_blank", answer: ["quote"] },
            { id: "q9", text: "Give clothes to the ______ shop", type: "fill_blank", answer: ["charity"] },
            { id: "q10", text: "Fridge and ______ to Andrea.", type: "fill_blank", answer: ["microwave"] },
          ],
        },
      ],
    },

    {
      id: "s2",
      title: "Section 2: Introduction to Counselling Services",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 11–14: Which counsellor should you see? Write the correct letter, A, B or C, next to Questions 11–14.",
          image: null,
          optionsBox: ["A. Louise Bagshaw", "B. Tony Denby", "C. Naomi Flynn"],
          mapOptions: ["A", "B", "C"],
          questions: [
            { id: "q11", text: "If it is your first time to see a counsellor", type: "map", answer: "C" },
            { id: "q12", text: "If you are unable to see a counsellor during normal office hours", type: "map", answer: "C" },
            { id: "q13", text: "If you do not arrange an appointment", type: "map", answer: "A" },
            { id: "q14", text: "If your concerns are associated with anxiety", type: "map", answer: "B" },
          ],
        },
        {
          instruction:
            "Questions 15–20: Complete the table below. Write ONE WORD ONLY for each answer.",
          heading: "Workshops",
          image: null,
          questions: [
            { id: "q15", text: "Adjusting (what you need to succeed in academic sections) — Target group: ______ students", type: "fill_blank", answer: ["first-year", "first year", "firstyear"] },
            { id: "q16", text: "Getting organised (manage time efficiently, achieve ______ between study and leisure) — Target group: all students", type: "fill_blank", answer: ["balance"] },
            { id: "q17", text: "Communicating (talking with staff, communicating across cultures) — Target group: all students, especially ______ students", type: "fill_blank", answer: ["international", "foreign"] },
            { id: "q18", text: "Anxiety (______ breathing techniques, meditation, etc.) — Target group: students about to sit exams", type: "fill_blank", answer: ["relaxation"] },
            { id: "q19", text: "Workshop: ______ (staying on track for long periods)", type: "fill_blank", answer: ["motivation"] },
            { id: "q20", text: "Target group of that workshop: ______ students only", type: "fill_blank", answer: ["research", "advanced"] },
          ],
        },
      ],
    },

    {
      id: "s3",
      title: "Section 3: Discussion of an Experiment",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction: "Questions 21–25: Choose the correct letter, A, B or C.",
          image: null,
          questions: [
            {
              id: "q21",
              text: "What has Irene recently done?",
              type: "mcq",
              options: [
                "A. She has almost finished planning the experiment.",
                "B. She is not applying herself enough to her work.",
                "C. She spends plenty of time in the lab.",
              ],
              answer: "C",
            },
            {
              id: "q22",
              text: "What is Bill's attitude towards Kim?",
              type: "mcq",
              options: [
                "A. He is grateful for Kim's contribution.",
                "B. He is not fond of Kim's tastes in clothes.",
                "C. He thinks Kim is not good at laboratory work.",
              ],
              answer: "A",
            },
            {
              id: "q23",
              text: "How does Jen find the other people in the group?",
              type: "mcq",
              options: [
                "A. The boys are good at maths which is very helpful.",
                "B. They would fail the experiment without Irene's contribution.",
                "C. Irene has completed the data analysis so the experiment is nearly done.",
              ],
              answer: "C",
            },
            {
              id: "q24",
              text: "How did Jen and Bill feel about Linda?",
              type: "mcq",
              options: [
                "A. She always handed in her work late for the group work.",
                "B. She was hard to get in touch with.",
                "C. She thought it was easy to get a high score.",
              ],
              answer: "B",
            },
            {
              id: "q25",
              text: "Why was Jen invited to the professor's personal project?",
              type: "mcq",
              options: [
                "A. She was quite popular among students.",
                "B. She always finishes reading all the assignments.",
                "C. She was closer to the professor.",
              ],
              answer: "B",
            },
          ],
        },
        {
          instruction:
            "Questions 26–30: What task has been distributed to each person? Choose FIVE answers from the box and write the correct letter, A–F, next to Questions 26–30.",
          heading: "Tasks",
          image: null,
          optionsBox: [
            "A. Acknowledgement",
            "B. Methodology",
            "C. Bibliography",
            "D. Literature review",
            "E. Results",
            "F. Discussion",
          ],
          mapOptions: ["A", "B", "C", "D", "E", "F"],
          questions: [
            { id: "q26", text: "Irene", type: "map", answer: "B" },
            { id: "q27", text: "Kate", type: "map", answer: "E" },
            { id: "q28", text: "Jen", type: "map", answer: "D" },
            { id: "q29", text: "Bill", type: "map", answer: "F" },
            { id: "q30", text: "Linda", type: "map", answer: "C" },
          ],
        },
      ],
    },

    {
      id: "s4",
      title: "Section 4: Expertise in Creative Writing",
      audioSrc: AUDIO_SRC,
      questionGroups: [
        {
          instruction:
            "Questions 31–40: Complete the flow-chart below. Write NO MORE THAN TWO WORDS for each answer.",
          heading: "Expertise in creative writing",
          image: null,
          flow: [
            { qid: "q31" },
            { qid: "q32" },
            { text: "Posed initial question — why do some people become experts while others don't?" },
            { qid: "q33" },
            { qid: "q34" },
            { qid: "q35" },
            { qids: ["q36", "q37"] },
            { text: "Gather similar data from experienced writers" },
            { qid: "q38" },
            { qid: "q39" },
            { qid: "q40" },
          ],
          questions: [
            { id: "q31", text: "Background — researcher had previously studied ______", type: "fill_blank", answer: ["English literature", "literature"] },
            { id: "q32", text: "Had initial idea for research — inspired by a book { the ______ of a well-known novelist }.", type: "fill_blank", answer: ["autobiography"] },
            { id: "q33", text: "Read expertise research in different fields, avoided studies carried out in a ______ because they're too controlled.", type: "fill_blank", answer: ["lab", "laboratory"] },
            { id: "q34", text: "Most helpful studies — research into ______ e.g. waiting tables.", type: "fill_blank", answer: ["practical skills"] },
            { id: "q35", text: "Found participants: four true ______ in creative writing (easy to find) and four with extensive experience.", type: "fill_blank", answer: ["novelists", "novelist"] },
            { id: "q36", text: "Adopting 'think aloud' techniques to collect ______ data from an inexperienced writer.", type: "fill_blank", answer: ["experimental"] },
            { id: "q37", text: "{ during session — assistant made ______ recordings }", type: "fill_blank", answer: ["video"] },
            { id: "q38", text: "Compared two sets of data and generated a ______ for analysis (identified five major stages in writing — will be refined later).", type: "fill_blank", answer: ["framework"] },
            { id: "q39", text: "Got an expert ______ to evaluate the quality of the different products.", type: "fill_blank", answer: ["editor"] },
            { id: "q40", text: "Identified the most effective ______ of stages in producing text.", type: "fill_blank", answer: ["sequence"] },
          ],
        },
      ],
    },
  ],
};

export default IELTS_MOCK7_LISTENING;
